<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <profile />

      <div class="navbar-brand">
        <span v-if="$store.state.business" class="m-r-2">{{ $store.state.business.title }}</span>
        <span v-else class="m-r-2">ROOT</span>
        <span @click="$modal.show('profile')" class="badge badge-info m-r-2" role="button">
          <span class="ti-pencil color-white"></span>
        </span>
        <span>
          {{ $store.state.user.phone | phoneFormat }}
        </span>
        <!-- <div class="navbar-title" v-if="routeName">
          <span v-if="routeName">{{ routeName }}</span>
          <template>
            <svg class="svg-angle svg-angle-1" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"></path></svg>
            <svg class="svg-angle svg-angle-2" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"></path></svg>
          </template>
        </div> -->
      </div>

      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <!--
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li>
        </ul>
      </div> -->
    </div>
  </nav>
</template>
<script>
import { mapState } from "vuex";
import Profile from "../../components/Profile.vue";
export default {
  components: { Profile },
  computed: {
    routeName() {
      const { path } = this.$route;
      for (let i = 0; i < this.routes.length; i++) {
        if ("/" + this.routes[i].path === path) {
          return this.capitalizeFirstLetter(this.routes[i].title);
          break;
        }
      }
    },
    ...mapState(["routes"]),
  },
  data() {
    return {
      activeNotifications: false,
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
  },
};
</script>
<style>
</style>
